export default [
  {
    title: 'Assistant IA',
    route: 'apps-chat-ai',
    icon: 'MessageSquareIcon',
    // action: 'read',
    // resource: 'Chat',
    action: 'read_archives',
    resource: 'Bibliothèque',
  },
]
